export default __webpack_public_path__ + "fonts/FontSiteSans-LightCdIt-webfont.ttf";